import React, {Component} from "react"
import {Input, Checkbox} from "formsy-react-components"
import ApplicationCheckboxGroup from "../../../components/form/ApplicationCheckboxGroup"
import BootstrapSingleDatePicker from "../../../components/BootstrapSingleDatePicker"
import AsyncUserMultiSelect from "../../../components/AsyncUserMultiSelect"
import Form from "../../../components/form/Form"
import FormHrLine from "../../../components/FormHrLine"
import {format, parse} from "../../../util/DateUtil"
import {omitByIsNil} from "../../../constants"
import {alertWarning} from "../../../util/AlertUtil"
import EnterpriseAccountSubTypeSelect from "../../../components/form/EnterpriseAccountSubTypeSelect"

class EnterpriseAccountWithLicenseForm extends Component {

  constructor() {
    super()
    this.state = {
      disabled: true,
      startDate: null,
      expirationDate: null,
      staff: [],
      user: []
    }
  }

  enableSubmitButton = () => {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = () => {
    this.setState({
      disabled: true
    });
  }

  submitForm = (data) => {

    const {subType, licenseeName, licenseeEmail, limit, name, accountManager, applications, remarks, expiryAlertEnabled, expiryAlertDays} = data

    if(_.isEmpty(applications)){

      alertWarning("Application is not selected.", "")

    } else{
      const licenseId = this.props.enterpriseAccount ? op.get(_.first(this.props.enterpriseAccount.licenses), 'id') : null

      const license = {
        id: licenseId,
        licenseeName,
        licenseeEmail,
        limit:_.toNumber(limit),
        applications,
        expiryAlertEnabled,
        expiryAlertDays: _.toNumber(expiryAlertDays),
        startDate: format(this.state.startDate),
        expirationDate: format(this.state.expirationDate),
      }
      const account = {
        id: op.get(this.props.enterpriseAccount, 'id'),
        name,
        accountManager,
        remarks,
        subType,
        license: omitByIsNil(license),
        staff: this.state.staff.map((u) => u.value),
        // authorizedUsers: this.state.user.map((u)=>u.value)
      }

      this.props.onSubmit(omitByIsNil(account))

    }


  }

  componentWillReceiveProps(nextProps) {

    const mapNSort = (it) => it.map((u) => ({
      value: u.id,
      label: u.emailAddress
    })).sort((a, b) => a.label.localeCompare(b.label))

    const newId = op.get(nextProps.enterpriseAccount, 'id')
    const currentId = op.get(this.props.enterpriseAccount, 'id')

    if (newId && _.isNil(currentId)) {
      const license = this.processAccount(nextProps.enterpriseAccount).license

      const staff = op.get(nextProps.enterpriseAccount, 'staff', [])

      this.setState({
        subType: nextProps.enterpriseAccount.subType,
        startDate: license.startDate,
        expirationDate: license.expirationDate,
        expiryAlertEnabled: license.expiryAlertEnabled,
        staff: mapNSort(staff)
      })
    }

  }

  processAccount(account) {
    const {name, accountManager, remarks, staff, authorizedUsers, subType} = account
    const license = _.first(account.licenses) || {}

    return {
      name,
      accountManager,
      remarks,
      subType,
      license: {
        id: license.id,
        licenseeName: license.licenseeName,
        licenseeEmail: license.licenseeEmail,
        limit: license.limit,
        expiryAlertDays: license.expiryAlertDays,
        expiryAlertEnabled: license.expiryAlertEnabled,
        applications: license.applications,
        startDate: parse(license.startDate),
        expirationDate: parse(license.expirationDate),

      },
      staff,
      authorizedUsers

    }
  }

  render() {


    const data = op.get(this.props.enterpriseAccount, 'id') ? this.processAccount(this.props.enterpriseAccount) : {}

    const handleStaffSelectChange = (value) => {
      this.setState({staff: value});
    }

    const handleUserSelectChange = (value) => {
      this.setState({user: value});
    }

    let subType = op.get(data, 'subType')

    return (
      <div className="p-w-lg">

        <Form
          onSubmit={this.submitForm}
          onValid={this.enableSubmitButton}
          onInvalid={this.disableSubmitButton}
          validatePristine={false}
          ref="enterpriseAccountForm">

          <div className="form-group">
            <Input
              name="name"
              value={op.get(data, 'name')}
              label="Name"
              type="text"
              placeholder="Enterprise Account Name"
              required
            />
          </div>

          <div className="form-group">
            <ApplicationCheckboxGroup
              name="applications"
              value={op.get(data, 'license.applications', []).map((app) => app.id)}
              required
            />
          </div>

          <div className="form-group">
            <Input
              name="limit"
              min={0}
              value={op.get(data, 'license.limit', 0)}
              label="Limit"
              type="number"
              placeholder="Number of licenses"
              required
            />
          </div>

          <div className="form-group">
            <label className="control-label col-sm-3">
              Start Date
            </label>
            <div className="col-sm-9">
              <BootstrapSingleDatePicker
                value={this.state.startDate}
                onApply={(e, v) => {
                  this.setState({startDate: v})
                }}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="control-label col-sm-3">
              Expiration Date
            </label>
            <div className="col-sm-9">
              <BootstrapSingleDatePicker
                value={this.state.expirationDate}
                onApply={(e, v) => {
                  this.setState({expirationDate: v})
                }}
              />
            </div>
          </div>


          <Checkbox
            name="expiryAlertEnabled"
            value={this.state.expiryAlertEnabled}
            label=""
            onChange={(name, value) => {
              this.setState({expiryAlertEnabled: value})
            }}
            rowLabel="Expiry Alert"
            valueLabel=""
          />

          <Input name="expiryAlertDays"
                 type="number"
                 min={0}
                 required={this.state.expiryAlertEnabled}
                 disabled={!this.state.expiryAlertEnabled}
                 style={{width: 70}}
                 value={op.get(data, 'license.expiryAlertDays')}
                 help="Number of days before license expire. Enterprise Manager and Account Manager will be alert via email."
          />

          <FormHrLine/>

          <div className="form-group">
            <Input
              name="licenseeName"
              label="Customer Name"
              type="text"
              value={op.get(data, 'license.licenseeName')}
              placeholder="Customer Name"
            />
          </div>

          <div className="form-group">
            <Input
              name="licenseeEmail"
              label="Customer Email"
              type="email"
              value={op.get(data, 'license.licenseeEmail')}
              placeholder="Customer Email"
              validations="isEmail"
              validationErrors={{
                isEmail: 'This doesn’t look like a valid email address.'
              }}

            />
          </div>

          <div className="form-group" style={{'textAlign': 'left'}}>

            <div className="form-group row">
              <label className="control-label col-sm-3">Enterprise Manager</label>
              <AsyncUserMultiSelect
                className="col-sm-9"
                name="staff"
                value={this.state.staff}
                onChange={handleStaffSelectChange}
              />
            </div>

          </div>

          <div className="form-group">
            <Input
              name="accountManager"
              label="Neeuro Account Manager"
              type="text"
              value={op.get(data, 'accountManager')}
              placeholder="Neeuro Account Manager"
            />
          </div>

          <FormHrLine/>

          <div className="form-group">
            <Input
              name="remarks"
              label="Remarks"
              type="text"
              value={op.get(data, 'remarks')}
              placeholder="Remarks"
            />
          </div>

          <div className="form-group">
            <EnterpriseAccountSubTypeSelect
              name="subType"
              onChange={(name, type)=>{
                this.setState({subType:type})
              }}
              value={subType}/>
          </div>

          <div className="form-group" style={{'textAlign': 'right'}}>
            <div className="col-sm-4 col-sm-offset-8">
              <input className="btn btn-primary"
                     formNoValidate={false} type="submit"
                     disabled={this.state.disabled}
                     defaultValue="Save Changes"/>
            </div>
          </div>

        </Form>
      </div>
    )
  }
}

export default EnterpriseAccountWithLicenseForm



// WEBPACK FOOTER //
// ./src/routes/admin/components/EnterpriseAccountWithLicenseForm.js